import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const Loader = () => {
  const classes = useStyles();

  return (
    <div className={classes.circularProgress}>
      <CircularProgress size={32} />
    </div>
  );
};

const useStyles = makeStyles({
  circularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "20rem"
  }
});
